import styled, { CSSObject } from 'styled-components';

export const IconWrapper = styled.span(({ theme }) => ({
  display: 'inline-flex',
  marginRight: theme.space[2],
}));

interface TabStyledProps {
  placement?: string;
  active?: boolean;
}

const generateUnderliningBlock = (background: string | number): CSSObject => ({
  '::after': {
    content: "''",
    display: 'block',
    position: 'absolute',
    left: 0,
    bottom: 0,
    height: 2,
    width: '100%',
    background,
  },
});

export const TabStyled = styled.div<TabStyledProps>(
  ({ theme, active, placement }) => {
    let styleSheet: CSSObject = {
      cursor: 'pointer',
      display: 'inline-flex',
      alignItems: 'center',
      padding: `${theme.space[2]} ${theme.space[4]} ${theme.space[4]} ${theme.space[4]}`,
      fontSize: theme.font.size.default,
      background: theme.color.wfWhite,
      color: theme.color.wfBlack,
      boxSizing: 'border-box',
      position: 'relative',

      '-webkit-user-select': 'none' /* Safari */,
      '-moz-user-select': 'none' /* Firefox */,
      '-ms-user-select': 'none' /* IE10+/Edge */,
      'user-select': 'none' /* Standard */,
    };

    if (placement === 'center') {
      styleSheet = {
        ...styleSheet,
        flexGrow: 1,
        justifyContent: 'center',
      };
    }

    if (active) {
      styleSheet = {
        ...styleSheet,
        color: theme.color.primary,
        fontWeight: theme.font.weight.bold,
        ...generateUnderliningBlock(theme.color.wfBlack),
      };
    } else {
      styleSheet = {
        ...styleSheet,
        ':hover': {
          ...generateUnderliningBlock(theme.color.wfGrey400),
        },
      };
    }

    return styleSheet;
  },
);
